import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HeaderPlanter } from './header-planter';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HeaderPlanter, multi: true },
];
